import { AccordionDetails, Box, Button } from "@mui/material";
import React, { Suspense, useEffect, useState } from "react";
import styled from "styled-components";
import ImageComponent from "../ImageComponent";
import ButtonDropDown from "../../../ButtonDropDown";

const DetailsDiv = styled(AccordionDetails)(({ theme }) => ({
  background: "#fff",
  "& img": {
    height: "50px",
    width: "50px",
    objectFit: "contain",
    borderRadius: "5px",
  },
  "& p": {
    margin: "0",
    marginTop: "10px",
    marginBottom: "0",
  },
  "& small": {
    color: "grey",
    fontSize: "12px",
    lineHeight: "1.4",
  },
}));



const OrderDetails = ({ handlePickupOrder, handlePrint, handleMarkPick, fulfilled, order, markPick }) => {
  
  const handleClickPrint = (val, row) => {
    handlePrint(val, row);
  };

  // console.log("order details", order.sales_details[0]);

  return (
    <div>
      <DetailsDiv>
        {order?.sales_details?.map((sales, index) => {
          return (
            <Box
              display={"grid"}
              gridTemplateColumns={"1fr 3fr 0.5fr 1fr"}
              alignItems={"center"}
              gap="10px"
              key={sales.id}
              mb={1}
            >
              <div>
                <Suspense>
                  <ImageComponent
                    imageUrl={sales?.ax_relation?.imageUrl}
                    alt={`sales-${sales.id}`}
                  />
                </Suspense>
              </div>
              <div>
                <p>{sales?.ax_relation?.ItemName}</p>
                <div style={{ lineHeight: "1.0" }}>
                  <small>Colour: {sales?.ax_relation?.ColourName}</small>
                  <br />
                  <small>Size: {sales?.ax_relation?.SizeID}</small>
                </div>
              </div>
              <div>
                <p>{parseInt(sales?.amount)}</p>
              </div>
              <div>${sales.finalPriceWithVAT}</div>
            </Box>
          );
        })}
        <Box
          display={"flex"}
          alignItems={"center"}
          justifyContent={"center"}
          style={{ borderTop: "1px solid #999" }}
          pt={2}
          gap={"15px"}
        >
          <Button
            variant="contained"
            color="primary"
            onClick={() => handlePrint("Print",order)}
            style={{ marginRight: "10px" }}
          >
            Pickup Slip
          </Button>

          <Button
            variant="contained"
            color="primary"
            onClick={() => handlePrint("Print A4",order)}
            style={{ marginRight: "10px" }}
          >
            Pickup A4 Slip
          </Button>

          {markPick ? (
            <Button
            variant="contained"
            color="secondary"
            onClick={() => handleMarkPick(order)}
            >
              Mark as Picked
            </Button>
          ) : ""}

          {!markPick && !fulfilled ? (
            <Button
              variant="contained"
              color="secondary"
              onClick={() => handlePickupOrder(order)}
            >
              Pickup Order
            </Button>
          ) : (
            ""
          )}
        </Box>
      </DetailsDiv>
    </div>
  );
};

export default OrderDetails;
